<div class="referral-dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0 mb-24">
        <div fxFlex fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">{{title}}</span>
            <button mat-icon-button class="mat-icon-button white-fg" (click)="dialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 m-0 pt-0" fusePerfectScrollbar>
        <form class="add-referral-form" [formGroup]="form" #formControl="ngForm" fxLayout="column" fxFlex>

            <div class="card referral-card">
                <div class="card-header"><span class="header-label">Referral</span></div>
                <div class="card-main" fxFlex fxLayout=row>
                    <mat-form-field class="p-8 m-0 form-control mat-form-field-wrapper"
                        style='width:220px!important;min-width:220px!important;margin-right:30px!important;'>
                        <mat-label>Source</mat-label>
                        <mat-select id="referralSource" class="form-control"
                            formControlName="referralSourceId" name="referralSource" required [setFocus]="true">
                            <mat-option *ngFor="let item of referralSources" [value]="item.id">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <!-- <mat-form-field class="p-8 m-0 form-control mat-form-field-wrapper"
                        style='width:220px!important;min-width:220px!important; margin-left:30px!important;margin-right:30px!important;'>
                        <mat-select id="referralUser" class="form-control" placeholder="Assigned To"
                            formControlName="referralUserId" name="referralUser">
                            <mat-option *ngFor="let item of referralUsers" [value]="item.id">
                                {{item.fullName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field> -->
                </div>
                <validation-errors style="padding-left: 8px; margin-top: -8px;"
                    [control]="form.get('referralSourceId')">
                </validation-errors>
            </div>

            <!--PRIMARY SUBJECT-->
            <div class="card" [ngStyle]="{'min-height.px':(subject?.sizeY)+72,'padding':'-24px'}">
                <div class="card-header"><span class="header-label">{{subject?.subjectType?.name}} Referral</span></div>
                <div class="card-main">
                    <subject-edit [subject]="subject?.subject" (onChanged)="subjectChanged($event)"
                        (onLayoutChanged)="layoutChanged($event)" [ngStyle]="{'height.px':(subject?.sizeY)}">
                    </subject-edit>
                </div>
            </div>

            <div class="contact-detail-section" fxLayout="row">
                <simple-contact-details class="contact-details" [form]="form" prefix="referrer" title="Referrer">
                </simple-contact-details>
                <simple-contact-details class="contact-details" [form]="form" prefix="manager" title="Manager">
                </simple-contact-details>
            </div>
        </form>
    </div>
    <div mat-dialog-actions class="m-0 p-24" fxLayout="row" fxLayoutAlign="space-between center">
        <div>
            <button mat-raised-button id="btnReferralSave" type="submit"
                [disabled]="((!form.valid) || (form.pristine)) || (!subject.canSave)" (click)="save()"
                class="save-button mat-accent" aria-label="SAVE">
                SAVE
            </button>
        </div>
    </div>
</div>